import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-two',
  templateUrl: './demo-two.component.html',
  styleUrls: ['./demo-two.component.css']
})
export class DemoTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
